module.exports = require("@pb/kit-component-menu");